// @ts-check
import { Trans } from '@lingui/macro';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useMatchSuppliers } from '~/components/MapSuppliers/SuppliersOverview';
import { useMatchSupplier } from '~/components/MatchSupplier/MatchSupplier';
import { Flex } from '~/design-system';
import { getNextSupplierName } from '../$supplierName';
import SearchCompany, {
  useSearchCompany,
} from '../../../../../../components/AddNewCompany/SearchCompany';
import Footer, {
  BackButton,
  CancelButton,
} from '../../../../../../components/Layout/Footer';
import Layout from '../../../../../../components/Layout/Layout';
import Main from '../../../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
} from '../../../../../../components/Layout/PageHeader';
import { ProgressIndicator, useLink } from '../../_config';

export default function SearchCompanyPage({ match }) {
  const history = useHistory();
  const link = useLink('suppliers');
  const { workspaceId, supplierName, importId } = match.params;
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const matchSupplierProps = useMatchSupplier(match.params);
  const matchSuppliersProps = useMatchSuppliers({
    workspaceId,
    importId,
  });
  const props = useSearchCompany();
  const { inviteCompany, company } = props;
  // const props = useAddSupplier();

  async function handleSelectCompany(company) {
    if (isSubmitting) return;
    setIsSubmitting(true);

    if (!company.brandId) throw new Error('brandId is required');
    await matchSupplierProps.onSubmit({ companyId: company.brandId });
    const { unmatchedSuppliers, supplierName } = matchSupplierProps;
    const nextSupplierName = getNextSupplierName({
      unmatchedSuppliers,
      supplierName,
    });
    setIsSubmitting(false);

    if (nextSupplierName) {
      return history.push(
        link._all.supplier({ supplierName: nextSupplierName })
      );
    }
    history.push(link._all.suppliers());
  }

  async function handleCreateCompany() {
    if (isSubmitting) return;
    setIsSubmitting(true);
    const { name, website, email, country } = company;
    const { data } = await inviteCompany(
      {
        name,
        website,
        email,
        country,
        companyType: 'wine',
      },
      true
    );
    const workspaceId = data.result.company.brandId;
    if (data.result.success) {
      await handleSelectCompany({ brandId: workspaceId });
    }
    await matchSuppliersProps?.refetch?.();
    setIsSubmitting(false);
    history.push(link._all.suppliers());
  }

  return (
    <Layout>
      <ProgressIndicator step="matchSuppliers" />
      <PageHeader>
        {/* <PageTitle>
          <Trans>Possible matches</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Check if the producer is listed</Trans>
        </PageSubtitle> */}
        <PageSubtitle>
          <Trans>Matching "{supplierName}"</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <Flex sx={{ margin: '0 auto' }}>
          <SearchCompany
            {...props}
            onSelectCompany={handleSelectCompany}
            onCreateCompany={handleCreateCompany}
          />
        </Flex>
      </Main>
      <Footer>
        <BackButton
          to={link._all.createCompany({ supplierName, companyData: company })}
        />
        <CancelButton to={link.cancel()} />
      </Footer>
    </Layout>
  );
}
